<template>
  <div class="wrapper">欢迎使用MKT广告后台!</div>
</template>

<script>
export default {
  methods: {},
};
</script>
<style rel="stylesheet/scss" lang="scss" scoped>
.wrapper {
  width: 100%;
  height: 100%;
  text-align: center;
  font-size:30px;
  padding-top:100px;
}
</style>
